/**
 * Created by fworld on 2019/7/24.
 */
export default {
    title: {
        show: false,
        text: '设备异常增长率分布',
        x: 'center',
        top: '0',
        left: '8%',
        textStyle: {
            color: '#c2c2c2'
        }
    },
    tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c} ({d}%)'
    },
    grid: {
        top: '20%',
        left: '15%',
        right: '15%'
    },
    xAxis: {
        name: '产品型号',
        nameTextStyle: {
            color: '#e1e1e1',
        },
        axisLabel: {
            color: '#e1e1e1',
        },
        axisLine: {
            lineStyle: {
                color: '#3c3c3c',
            }
        },
        type: 'category',
        data: ['F11', 'F02']
    },
    yAxis: {
        type: 'value',
        name: '异常次数总计',
        axisLabel: {
            color: '#BAC3CE',
        },
        nameTextStyle: {
            color: '#e1e1e1',
        },
        axisLine: {
            lineStyle: {
                color: '#3c3c3c',
            }
        },
        splitLine: {
            lineStyle: {
                type: 'dotted'
            }
        }
    },
    series: [{
        data: [120, 160],
        type: 'bar',
        barMaxWidth: '80',
    }]
}
